import React from 'react'
import { useDispatch } from 'react-redux'
import { deleteNotes, updateNote } from '../../redux/features/addNotesSlice'

import deleteicon from "../../assets/images/icons/deleteicon.svg";

const NotesComponent = ({ notes }) => {
  const dispatch = useDispatch()

  const onNoteChange = (event, value) => {
    const updatedNote = {...value, note: event.target.value, isEdit: false}
    
    dispatch(
      updateNote(updatedNote),
    )
    

  }
  const onNoteChangeEdit = (value) => {
  
    const updatedNote = {...value, isEdit: true}
    
    dispatch(
      updateNote(updatedNote),
    )
 }



 const deleteNote = (note) => {
   dispatch(deleteNotes(note))
 }
  return (
    <div>
         {notes.length > 0 ? notes.map(note => {
            return (
              <div className='noteadded'>
              <div className='addnote'>
              <img src={note.img} alt="note" style={{padding: '8px 8px 0 0', width: '23px',height: '18px'}}/>
              {note.isEdit ?  <input className = "note-input" type="text" onBlur = {(event) => onNoteChange(event, note)}/> : <div className='addnote-text'><p onClick={(event) => onNoteChangeEdit(note)}>{note.note}</p></div>}
              </div>
              <div className='deleteimg'>
                { note.isEdit ? null : 
              <img style={{width: '11.67px',height: '16.67px',padding:'8px 0 0'}}src={deleteicon} alt="delete" onClick={() => deleteNote(note)}/>
                }
             </div>
              </div>
            )
            
          }): null}
    </div>
  )
}

export default NotesComponent